import { render, staticRenderFns } from "./VideoLengthSearchReplacer.vue?vue&type=template&id=207afa82"
import script from "./VideoLengthSearchReplacer.vue?vue&type=script&lang=js"
export * from "./VideoLengthSearchReplacer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports